<script setup lang="ts">

    import { LegalAdviceData } from '../interfaces';
    const { locale } = useI18n();
    const legalAdviceData = ref({} as LegalAdviceData);
    const isReady = ref(false);

    const request = {
        locale: [ locale.value ],
        populate: {
            seo: {
                fields: ['*']
            },
            titleImage: {
                fields: ['*']
            },
        },
    };

    const loadLegalAdviceData = async () => {
        return await $fetch(`/api/strapi/legal-advice`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                request
            })
        });
    }

    onMounted(async () => {
        const data: LegalAdviceData = await loadLegalAdviceData();
        legalAdviceData.value = data;
        isReady.value = true;
    });

</script>

<template>
    <div v-if="isReady">
        <Head>
            <Title>{{ legalAdviceData.attributes.seo.seoTitle }}</Title>
            <Meta name="description" :content="legalAdviceData.attributes.seo.seoDescription" />
            <Html :lang="locale" />
        </Head>
        <div class="membership-plans membership-header section-profile is-cover">
            <div
                class="profile-wrap is-cover"
                :style="{ backgroundImage: `url(${legalAdviceData.attributes.titleImage.data.attributes.url})` }"
            >
                <h1>
                    {{ legalAdviceData.attributes.title }}
                </h1>
                <h2>
                    {{ legalAdviceData.attributes.description }}
                </h2>
            </div>
        </div>

        <article>
            <div class="section-post wrap">
                <div id="content" class="post-wrap" v-html="legalAdviceData.attributes.content"></div>
            </div>
        </article>
    </div>
</template>